


























































import { Component, Prop, Provide, Vue } from "vue-property-decorator";
import BannerTmp from "./../../common/banner/bannerTop.vue";
import EffectTmp from "./../../common/effect_footer/effect_footer.vue";
@Component({
    components:{
        BannerTmp,EffectTmp
    }
})
export default class batchTOBIndex extends Vue {
    //向子组件传值
    //protected 修饰的属性或者方法是私有的，但它的子组件可以访问到
    protected bannerData: object = {
        imgUrl: require('../../../../static/images/banner_batchTOB.png'),
        title: '运营商To B业务批量填单',
        subTitle: '轻松助力业务降本增效'
    };
    public list: any= [
        {imgUrl: require('../../../assets/images/solution/batchTOB/tob_1.png'), title: '繁琐重复', des: '每天投入机械重复的劳动，劳动价值低。'},
        {imgUrl: require('../../../assets/images/solution/batchTOB/tob_2.png'), title: '耗时耗力', des: '大量信息填写，比对等操作耗时耗力。'},
        {imgUrl: require('../../../assets/images/solution/batchTOB/tob_3.png'), title: '沟通成本高', des: '流程冗长，需要大量时间进行沟通，沟通成本高。'}
    ];

    public frontArr: any= [
        {imgUrl: require('../../../assets/images/solution/batchTOB/tob_6.svg'), number: 1, text: '填写业务申请单'},
        {imgUrl: require('../../../assets/images/solution/batchTOB/tob_7.svg'), number: 2, text: '登录系统'},
        {imgUrl: require('../../../assets/images/solution/batchTOB/tob_8.svg'), number: 3, text: '打开业务数据表'},
        {imgUrl: require('../../../assets/images/solution/batchTOB/tob_9.svg'), number: 4, text: '选择业务及产品并将数据录入申请单'},
        {imgUrl: require('../../../assets/images/solution/batchTOB/tob_10.svg'), number: 5, text: '重复上个步骤直至数据表信息录入完成'},
        {imgUrl: require('../../../assets/images/solution/batchTOB/tob_11.svg'), number: 6, text: '对比数据表与申请单信息'},
        {imgUrl: require('../../../assets/images/solution/batchTOB/tob_12.svg'), number: 7, text: '填写执行结果'}
    ];
    public afterArr: any= [
        {imgUrl: require('../../../assets/images/solution/batchTOB/tob_13.svg'), number: 1, text: '获取数据并自动填写业务申请单'},
        {imgUrl: require('../../../assets/images/solution/batchTOB/tob_14.svg'), number: 2, text: '登录系统'},
        {imgUrl: require('../../../assets/images/solution/batchTOB/tob_15.svg'), number: 3, text: '上传业务数据表'},
        {imgUrl: require('../../../assets/images/solution/batchTOB/tob_16.svg'), number: 4, text: '选择业务及产品并将数据录入申请单'},
        {imgUrl: require('../../../assets/images/solution/batchTOB/tob_17.svg'), number: 5, text: '循环遍历业务数据表'},
        {imgUrl: require('../../../assets/images/solution/batchTOB/tob_18.svg'), number: 6, text: '获取执行结果'}
    ];
}

